// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Hj","hoverContainer":"e_Ij","tooltip":"e_Jj","active":"e_Kj","head":"e_Lj","text":"e_Mj"};